export const ONBOARDING_ENDPOINTS = {
  PASOS: '/api/v1/onboarding/pasos',
  PASO: (id: number) => `/api/v1/onboarding/pasos/${id}`,
  PASO_CONTENIDO: (id: number) => `/api/v1/onboarding/pasos/${id}/contenido`,
  CONFIGURACION: '/api/v1/onboarding/configuracion',
  RESETEAR: '/api/v1/onboarding/configuracion/resetear',
  MI_PROGRESO: '/api/v1/onboarding/mi-progreso',
  COMPLETAR: '/api/v1/onboarding/completar',
  ACEPTAR_TERMINOS: '/api/v1/onboarding/aceptar-terminos',
} as const;
